export const addBusinessEntityButtonLabel = (currentUser: {
  has_draft_first_business_entity_application: boolean;
}) => {
  return currentUser.has_draft_first_business_entity_application
    ? "下書き中の事業者情報を修正"
    : "新しい事業者を追加";
};
